import React, { Component } from "react";
import Slider from "react-slick";

import {
  Container,
  Heading,
  Subtitle,
  ResponsiveText,
  Spacing,
} from "./SponsorpageComponents";
import { Grid, ButtonBase, Button } from "@mui/material";
import sponsor1 from "../../assets/images/sponsor/github-logo.png";
import sponsor2 from "../../assets/images/sponsor/bevy-logo.png";
import sponsor3 from "../../assets/images/sponsor/google-logo.png";
import { Link } from "react-router-dom";
import { SponsorButton } from "../../common/strings";

import { SponsorHeading, SponsorInfo } from "../../common/strings.jsx";

export default class SponsorPage extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <div>
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Heading>{SponsorHeading}</Heading>
              <Subtitle>
                <ResponsiveText>{SponsorInfo}</ResponsiveText>
              </Subtitle>
            </Grid>
          </Grid>

          <Slider {...settings} style={{ height: "220px" }}>
            <div>
              <img src={sponsor1} alt="" />
            </div>
            <div>
              <img src={sponsor2} alt="" />
            </div>
            <div>
              <img src={sponsor3} alt="" />
            </div>
            <div>
              <img src={sponsor1} alt="" />
            </div>
            <div>
              <img src={sponsor2} alt="" />
            </div>
            <div>
              <img src={sponsor3} alt="" />
            </div>
          </Slider>
          <Spacing></Spacing>
          <Link
            to="/ContactUs"
            style={{
              display: "flex",
              textDecoration: "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              href="https://gdsc.community.dev/accounts/login/?next=/srm-institute-of-science-and-technology-ramapuram-chennai/"
              target="_blank"
              sx={{
                borderRadius: "100px",
                textTransform: "none",
                backgroundColor: "#005EDB",
                color: "#FFFFFF",
                "&:hover": { backgroundColor: "#005EDB", color: "#FFFFFF" },
                fontWeight: "700",
              }}
            >
              {SponsorButton}
            </Button>
          </Link>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={10} sx={{ textAlign: "center", mt: 1 }}>
              <ButtonBase sx={{ borderRadius: "60px" }}>
                <Spacing></Spacing>
              </ButtonBase>
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}
